import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Typography,
  Button,
  Chip
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import GetAppIcon from '@mui/icons-material/GetApp';

const useStyles = makeStyles({
  ava: {
    '& img': {
      objectFit: 'contain'
    }
  }
});

const PluginCard = ({
  plugin,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        bgcolor: 'background.default'
      }}
      {...rest}
    >
      <CardContent>
        <Box
          style={{
            position: 'relative'
          }}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            pb: 3
          }}
        >
          <Avatar
            alt="Product"
            src={plugin.image}
            variant="square"
            className={classes.ava}
          />
          {(plugin.status === 0) && (
            <Chip
              style={{
                position: 'absolute',
                top: 0,
                right: 0
              }}
              label="in progress"
              size="small"
              color="secondary"
            />
          )}
          {(plugin.status === 1) && (
            <Chip
              style={{
                position: 'absolute',
                top: 0,
                right: 0
              }}
              label="ready"
              size="small"
              color="primary"
            />
          )}
        </Box>
        <Typography
          align="center"
          color="textPrimary"
          gutterBottom
          variant="h4"
        >
          {plugin.title}
        </Typography>
      </CardContent>
      <Box sx={{ flexGrow: 1 }} />
      <Divider />
      <Box sx={{ p: 2 }}>
        <Grid
          container
          spacing={2}
          sx={{ justifyContent: 'space-between' }}
        >
          <Grid
            item
            sx={{
              alignItems: 'center',
              display: 'flex'
            }}
          >
            <GetAppIcon color="neutral" />
            <Typography
              color="text.secondary"
              display="inline"
              sx={{ pl: 1 }}
              variant="body2"
            >
              {plugin.downloads}
              {' '}
              { plugin.is_service ? 'Integrations' : 'Downloads' }
            </Typography>
          </Grid>
          <Grid
            item
            sx={{
              alignItems: 'center',
              display: 'flex'
            }}
          >
            <Typography
              color="textSecondary"
              display="inline"
              sx={{ pl: 1 }}
              variant="body2"
            >
              {((plugin.is_internal) && (
                <Button
                  to={plugin.url}
                  disabled={plugin.status === 0}
                  component={NavLink}
                >
                  Integrate
                </Button>
              )) || (
                <Button href={plugin.url} target="_blank" disabled={plugin.status === 0}>
                  {((plugin.is_service === 1) && (
                    <>
                      Integrate
                    </>
                  )) || (
                    <>
                      Download
                    </>
                  )}
                </Button>
              )}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Card>
  );
};

PluginCard.propTypes = {
  plugin: PropTypes.object.isRequired
};

export default PluginCard;
